import { Component, NgModule , OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef,
  OnChanges, TemplateRef, ViewChild, isDevMode} from '@angular/core';
import {DemoService} from '../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';
import { MysqlService } from './../../../services/mysql.service';

import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpRequest, HttpResponse, HttpEvent } from '@angular/common/http';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {BehaviorSubject, Observable, Subject, map, Subscription} from 'rxjs';

import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
import {SystemFile} from './../../../shared/models/file.model';

// Environmental Variables
import { environment } from './../../../../environments/environment';

@Component({
  selector: 'app-dbe-rest-admin',
  templateUrl: './dbe-rest-admin.component.html',
  styleUrls: ['./dbe-rest-admin.component.scss']
})
export class DbeRestAdminComponent implements OnInit {

  system_encryption_status_data: any;
  encryption_check_result: any;
  schema_encryption_result: any[] = [];
  isEncrypting = false;
  encryptionErrorLog: any[] = [];
  selectedSchema = 'rest_tsa_e'; // Can be dynamic if needed


  @Input() file_id?: Observable<any[]>;
  @Input() file_data?: any;
  @Input() permission_check?: boolean;
  file: SystemFile;


   // setup as observable?
   @Input() item_id?: Observable<any[]>; // impliments on changes.
   @Input() item_data?: Observable<any[]>; // if data.model is sent : Observable<any[]>;
   @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
   @Input() item_user_level_id? = '';
   @Input() item_brand_type_id? = '';
   @Input() show_buttons? = 'no'; // yes | no
   @Input() widget_title? = '';
   @Input() widget_size? = 'side'; // side | abstract | full
  returned_file_data: Object;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;
 
  


  constructor(
    private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute, public toastr: HotToastService,
     vcr: ViewContainerRef, private router: Router,
     public HttpClient:HttpClient,
     private _mysqlService: MysqlService,
     private modalService: BsModalService,
     public datepipe: DatePipe,
    public gfunc: GlobalFunctionsService



  ) {
// Set and Access login Session Variables
this.gfunc.setLoginSessionVars(); // set in a global function file
this.sessionUserId = this.gfunc.currentUserVAR.user_id;
this.sessionUsername = this.gfunc.currentUserVAR.username;
this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

// need to add this as routes does not work globally
this.all_router_details = this.router.url;
this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));

   }



      // check for changes. to load data.
      ngOnChanges(changes) {
        if (changes.item_id) {
          // deal with asynchronous Observable result
          // this.file_id = changes.item_id.currentValue;
              // load data from sent ID
              if (!this.file_data){
                // this.getSystemFile(this.file_id);
              }else{
             // this.file_data = this.returned_file_data;
              }
        }
      }

  ngOnInit() {

    if (isDevMode()) {
      console.log('Development!');
      console.log('fileURL: ', environment.$fileURL);
    } else {
      console.log('Production!');
    }

  }



  // getSystemFile(file_id){
  //   this._demoService.getSystemFile(file_id).subscribe(
  //      data => { this.file_data = data; },
  //      err => console.error(err),
  //      // () => console.log('done loading Trace Types')
  //    );
  //   }


// Get current table encryption status
getSystemDBEncyptionStatus() {
  this._demoService.getSystemDBEncyptionStatus().subscribe(
    data => {
      this.system_encryption_status_data = data;
    },
    err => {
      console.error(err);
      this.toastr.error('Failed to load encryption status');
    }
  );
}

// Verify server settings (innodb_encrypt_tables, etc.)
checkServerEncryptionSettings() {
  this._demoService.verifyDBEncryptionSettings().subscribe(
    data => {
      this.encryption_check_result = data;
    },
    err => {
      console.error(err);
      this.toastr.error('Failed to verify DB encryption settings');
    }
  );
}

// Encrypt all tables in schema
encryptEntireSchema() {
  this.isEncrypting = true;
  this.schema_encryption_result = [];
  this.encryptionErrorLog = [];

  this._demoService.encryptSchema(this.selectedSchema).subscribe(
    data => {
      this.schema_encryption_result = data.result;
      this.isEncrypting = false;

      const errors = data.result.filter(t => t.status === 'error');
      if (errors.length > 0) {
        this.encryptionErrorLog = errors;
        this.toastr.warning('Schema encryption completed with errors');
      } else {
        this.toastr.success('All tables encrypted successfully');
      }

      this.getSystemDBEncyptionStatus(); // Refresh status
    },
    err => {
      this.isEncrypting = false;
      this.toastr.error('Schema encryption failed');
      console.error(err);
    }
  );
}

// Encrypt a specific table
encryptTable(schema: string, table: string) {
  this._demoService.encryptTable(schema, table).subscribe(
    res => {
      this.toastr.success(`Encrypted: ${table}`);
      this.getSystemDBEncyptionStatus();
    },
    err => {
      this.toastr.error(`Failed to encrypt ${table}`);
      console.error(err);
    }
  );
}

}
